<template>
    <div>
        团长列表页面
    </div>
</template>

<script>
    export default {
        name: "colonelpage"
    }
</script>

<style scoped>

</style>
